import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toLower } from 'lodash';
import LinkButton from 'components/shared/button/LinkButton';
import DataModal from '../banner/DataModal';
import AccountDetails from '../account-plan/AccountDetails';
import AddAccount from '../account-plan/AddAccount';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';
import { Tooltip } from 'react-bootstrap';
import {
  getDarwinReports,
  getPlanData,
} from 'store/customer/customer-view-actions';
import { useQuery } from '@tanstack/react-query';
import { ACCOUNT_TYPE, QUERY_KEY } from 'constants/constants';

const Reports = () => {
  const [showModal, setShowModal] = useState(false);
  const [showAccModal, setShowAccModal] = useState(false);
  const [planData, setPlanData] = useState([]);
  const [darwinReport, setDarwinReport] = useState(false);
  const selections = useSelector((state) => state?.CustomerView?.selectedView);

  const contacts = useSelector((state) => state?.CustomerView?.contacts);
  const selectedCustomer = useSelector(
    (state) => state?.CustomerView?.selectedCustomer
  );
  const componentAccessList = useSelector(
    (state) => state?.Auth?.componentAccessList
  );
  const { unixId } = useSelector((state) => state.Auth.userClaimObject);

  const [showAddPlan, setShowAddPlan] = useState([]);

  // Fetch Darwin Reports data using React Query
  const { data: darwinReportsData = [] } = useQuery({
    queryKey: [QUERY_KEY.DarwinReportsData, selectedCustomer?.value],
    queryFn: async () => {
      // fetch darwin reports data
      let result = await getDarwinReports(selectedCustomer?.value);
      return result || [];
    },
    // only run the query if we have a selected customer
    enabled: !!selectedCustomer?.value && darwinReport,
  });

  useEffect(() => {
    if (!Array.isArray(selectedCustomer)) {
      getPlanDataDetails(selectedCustomer?.value);
      setShowAddPlan([]);
      setDarwinReport(false);
    }
  }, [selectedCustomer]);

  useEffect(() => {
    setShowAddPlan(
      contacts
        ? contacts?.filter(
            (value) =>
              value.primayContactFlag === 'Y' &&
              toLower(value.unixId) === toLower(unixId)
          )
        : []
    );
  }, [contacts]);

  const getPlanDataDetails = async (customerId) => {
    let data = await getPlanData(customerId);
    let currentPlan = data.filter((plan) => {
      return plan?.isActive === 'Y';
    });
    let previousPlan = data.filter((plan) => plan?.isActive !== 'Y');
    setPlanData({ currentPlan, previousPlan });
  };

  const onDelete = (planDetails) => {
    setPlanData(planDetails);
  };

  const tooltip = () => {
    return (
      <Tooltip className='gne-tooltip'>
        <span className='text text__x-small'>
          A plan for this
          {selections === ACCOUNT_TYPE.account ? ' account ' : ' site '}
          has not been added to date. If you are the primary point of contact
          for this
          {selections === ACCOUNT_TYPE.account ? ' account ' : ' site '}
          and would like to upload a plan, you must first designate yourself as
          the primary point of contact for this
          {selections === ACCOUNT_TYPE.account ? ' account ' : ' site '}
        </span>
      </Tooltip>
    );
  };

  return (
    <>
      <div className='d-flex justify-content-end align-items-center gap-3 mt-4 me-0'>
        {componentAccessList?.includes('Account-Plan') &&
          planData?.currentPlan?.length > 0 && (
            <LinkButton
              className='d-flex align-items-center me-2'
              onClick={() => setShowModal(true)}>
              <i className='icon icon__link_icon me-1'></i>
              <span className='title__bold title__small'>
                {selections === ACCOUNT_TYPE.account ? 'Account' : 'Site'} Plan
              </span>
            </LinkButton>
          )}

        {componentAccessList?.includes('Account-Plan') &&
          planData?.currentPlan?.length === 0 && (
            <LinkButton
              className={`d-flex align-items-center me-0 ${
                showAddPlan.length === 0 ? 'disabled' : ''
              }`}
              disabled={showAddPlan.length === 0}
              onClick={() => setShowAccModal(true)}>
              {showAddPlan.length === 0 ? (
                <OverlayTrigger overlay={tooltip()}>
                  <span className='title__bold title__small d-flex align-items-center'>
                    <i
                      className={`icon me-2 ${
                        showAddPlan.length === 0
                          ? 'icon__add-black'
                          : 'icon__add-blue'
                      }`}
                    />
                    Add{' '}
                    {selections === ACCOUNT_TYPE.account ? 'Account' : 'Site'}{' '}
                    Plan
                  </span>
                </OverlayTrigger>
              ) : (
                <span className='title__bold title__small d-flex align-items-center'>
                  <i
                    className={`icon me-2 ${
                      showAddPlan.length === 0
                        ? 'icon__add-black'
                        : 'icon__add-blue'
                    }`}
                  />
                  Add {selections === ACCOUNT_TYPE.account ? 'Account' : 'Site'}{' '}
                  Plan
                </span>
              )}
            </LinkButton>
          )}
        <div className=''>
          <LinkButton
            className={`d-flex align-items-center me-0 pe-0 ${
              !componentAccessList?.includes('Account-Plan') ? 'ms-auto' : ''
            }`}
            onClick={() => {
              setDarwinReport(true);
            }}>
            <div className='d-flex align-items-center'>
              <i className='icon icon__darwinReports me-2'></i>
              <span className='title__bold title__small'>Darwin</span>
            </div>
          </LinkButton>
        </div>
      </div>

      <DataModal
        data={darwinReportsData}
        show={darwinReport}
        onHide={() => setDarwinReport(false)}
      />

      {planData?.currentPlan?.length > 0 && (
        <AccountDetails
          show={showModal}
          open={() => setShowAccModal(true)}
          onHide={() => setShowModal(false)}
          data={planData}
          unixId={unixId}
          disableAdd={showAddPlan.length === 0 ? true : false}
          view={selections === ACCOUNT_TYPE.account}
          onDelete={onDelete}
        />
      )}

      <AddAccount
        show={showAccModal}
        onHide={() => setShowAccModal(false)}
        customerId={selectedCustomer?.value}
        unixId={unixId}
        onSave={() => getPlanDataDetails(selectedCustomer?.value)}
        view={selections === ACCOUNT_TYPE.account}
      />
    </>
  );
};

export default Reports;
